import { useQuery } from "react-query";
import { fetchUserCustomizations } from "./api";

export function useCustomizations(options = {}) {
  return useQuery(
    ["fetchUserCustomizations"],
    () => fetchUserCustomizations(),
    {
      staleTime: 60000 * 60,
      ...options,
    }
  );
}
